<template>
  <section class="loading-ip-login" aria-busy="true">
    <div role="status" aria-live="polite" aria-atomic="true" aria-label="Loading through your institution">
      <mcr-loading-indicator :loading="true" message="Loading through your institution..."></mcr-loading-indicator>
    </div>
  </section>
</template>

<script>
export default {
  name: 'LoadingIpLogin',
};
</script>

<style lang="scss" scoped>
@use '@common/style/variables';

.loading-ip-login {
  background-color: variables.$background-light;
  border-radius: 4px;
  padding: 20px;
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;

  &::v-deep .mcr-loading-indicator {
    .cube1,
    .cube2 {
      background-color: variables.$neutral-400;
    }
    .loading-message {
      color: variables.$neutral-800;
    }
  }
}
</style>
